import React from "react";
import NumberFormat from "react-number-format";
import UtilBloc from "../../../../bloc/util_bloc";
import AppTextFieldConfig from "./app_text_field_config";
import AppFieldTitle from "../app_field_title/app_field_title";
import AppFieldError from "../app_field_error/app_field_error";
import AppFieldSubtitle from "../app_field_subtitle/app_field_subtitle";
import { Input } from "antd";
import "./app_text_field.css";

class AppTextField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: "",
        };
    }

    //Title properties
    propLabel() { return this.props.label };
    propSubtitle() { return this.props.subtitle };
    propLabelFontColor() { return this.props.labelFontColor };

    //Properties
    propId() { return this.props.id };
    propType() { return this.props.type };
    propValue() { return this.props.value };
    propMaxLength() { return this.props.maxLength };
    propDisabled() { return this.props.disabled };
    propUnderline() { return this.props.underline };
    propLineColor() { return this.props.lineColor };
    propFontColor() { return this.props.fontColor };
    propPaddingTop() { return this.props.paddingTop };
    propPaddingBottom() { return this.props.paddingBottom };
    propPaddingRight() { return this.props.paddingRight };
    propPaddingLeft() { return this.props.paddingLeft };
    propFontWeight() { return this.props.fontWeight };
    propCompulsory() { return this.props.compulsory };
    propSubCompulsory() { return this.props.subCompulsory }
    propTextFormat() { return this.props.textFormat };
    propPlaceHolder() { return this.props.placeholder };
    propPrefixType() { return this.props.prefixType };
    propPrefixText() { return this.props.prefixText };
    propPrefixImageByCss () { return this.props.prefixImageByCss };
    propSuffixText() { return this.props.suffixText };
    propPrefix() { return this.props.prefix };
    propValidationMode() { return this.props.validationMode };
    propInputHeight() {return this.props.inputHeight || "40px"}
    propInputWidth () {return this.props.inputWidth || ""}

    //Listeners
    propOnChange() { return this.props.onChange };
    propOnFormat() { return this.props.onFormat };
    propOnBlur() { return this.props.onBlur };
    propOnValidate() { return this.props.onValidate };
    propOnKeyDown() { return this.props.onKeyDown };
    propErrorLabelGetter() { return this.props.errorLabelGetter };
 
    propDecimalScale() { return this.props.decimalScale || 0 };
    


    //States
    stateValue() { return this.state.value };
    stateError() { return this.state.error };

    componentDidMount() {
        this.setState({
            value: this.propValue(), //setting initial value to props value
            error: "",
        });
        if (!UtilBloc.isNullOrEmpty(this.propValue())) {
            this.onTextChangeValidate(this.propValue())
        }
    }

    componentDidUpdate(prevProps) {
        // let oldValue = prevProps.value;
        // let newValue = this.propValue();
        // if (oldValue !== newValue) {
        //     this.setState({
        //       value: newValue,
        //     });
        // }
    }

    //Controller method to update value
    updateValue(value) {
        this.onTextChange(value)
    }

    upperCaseValue(value) {
        return value.toUpperCase();
    }

    //Validate text on change
    onTextChangeValidate(value) {
        let error = "";
        this.setState({ value: value, error: error });
        error = this.onValidateListener(value, AppTextFieldConfig.validationMode.onChange)
        this.setState({
            error: error
        })
    }

    //Validate text on blur
    onTextBlurValidate(value) {
        let error = "";
        this.setState({ value: value, error: error });
        error = this.onValidateListener(value, AppTextFieldConfig.validationMode.onBlur)
        this.setState({
            error: error
        })
    }

    //On get error label
    onGetErrorLabel(error) {
        return this.onGetErrorLabelListener(error);
    }

    onTextChange(val) {
        let value = val
        //Convert to upper case if needed
        if (this.propTextFormat() == AppTextFieldConfig.textFormat.allCaps) {
            value = (value || "").toUpperCase()
        }

        if (this.propCompulsory() == AppTextFieldConfig.compulsory.true && this.propValidationMode() != AppTextFieldConfig.validationMode.onBlur) {
            this.onTextChangeValidate(value);
        }

        if (this.propSubCompulsory() == AppTextFieldConfig.compulsory.true && this.propCompulsory() == AppTextFieldConfig.compulsory.false) {
            this.onTextChangeValidate(value);
        }


        this.setState({ value: value });
        this.onChangeListener(value);
    }

    onTextBlur(value) {
        if (this.propCompulsory() == AppTextFieldConfig.compulsory.true && this.propValidationMode() == AppTextFieldConfig.validationMode.onBlur) {
            this.onTextBlurValidate(value);
        }
        this.onBlurListener(value);
    }

    onKeyDown(e) {
        this.onKeyDownListener(e)
    }

    //Text on change listener
    onChangeListener(value) {
        if (this.propOnChange()) this.propOnChange()(value);
    }

    //Text on validate listener
    onValidateListener(value, mode) {
        return this.propOnValidate() != null ? this.propOnValidate()(value, mode) : null;
    }

    //Text on blur (complete/lose focus) listener
    onBlurListener(value) {
        if (this.propOnBlur()) this.propOnBlur()(value);
    }

    //On keydown listener
    onKeyDownListener(e) {
        if (this.propOnKeyDown()) this.propOnKeyDown()(e);
    }

    //Process error label getter for display
    onGetErrorLabelListener(error) {
        return this.propErrorLabelGetter() ? this.propErrorLabelGetter()(error) : error;
    }

    //Enabled field
    enabledTextField() {
        return <Input
            id={this.propId() || ""}
            name={Math.random()}
            maxlength={this.propMaxLength() || 250}
            bordered={false}
            style={{
                border: "1px solid #808EA8",
                backgroundColor:"transparent",
                height: "40px",
                fontSize:"16px",
                borderRadius: "4px",
                color: `${this.propFontColor() == AppTextFieldConfig.fontColor.gray ? "#808EA8" : "#1D365E"}`,
                fontWeight: `${this.propFontWeight() == AppTextFieldConfig.fontWeight.bold ? "bold" : "normal"}`,
            }}
            value={this.stateValue()}
            maxLength={this.propMaxLength()}
            onChange={(e) => {
                if (this.propMaxLength()) {
                    if (e.target.value.length <= this.propMaxLength()) {
                        let currentText = e.target.value;                        
                        this.onTextChange(currentText);
                    }
                } else {
                    if (e.target.value.length <= 250) {
                        let currentText = e.target.value;                        
                        this.onTextChange(currentText);
                    }
                }


            }}
            onKeyDown={(e) => this.onKeyDown(e)}
            onBlur={(e) => {
                let currentText = e.target.value;
                this.onTextBlur(currentText);
            }}
            placeholder={this.propPlaceHolder()}
            autocomplete="off"
            aria-autocomplete="none"
        //disabled={this.propDisabled() == AppTextFieldConfig.disabled.true ? true : false}
        />
    }

    //Disabled field
    disabledTextField() {
        return <div
            id={this.propId() || ""}
            style={{
                border: "1px solid #808EA8",
                height: "40px",
                borderRadius: "4px",
                paddingLeft: "10px",
                paddingTop: "7px",
                fontSize:"16px",
                backgroundColor: "#E4EAF080",
                color: `${this.propFontColor() == AppTextFieldConfig.fontColor.gray ? "#808EA8" : "#1D365E"}`,
                fontWeight: `${this.propFontWeight() == AppTextFieldConfig.fontWeight.bold ? "bold" : "normal"}`,
            }}
            className={`form-control-disabled`}
            placeholder={this.propPlaceHolder()}
            disabled={this.propDisabled() == AppTextFieldConfig.disabled.true ? true : false}
        >
            {(this.propPrefixType() == AppTextFieldConfig.prefixType.text && this.propPrefix()) && <span>{this.propPrefix()} </span>}<span>{UtilBloc.isNullOrEmpty(this.stateValue()) ? '-' : this.stateValue()}</span>
        </div>
    }

    //Enabled number field
    enabledNumberField() {
        return <NumberFormat            
            id={this.propId() || ""}
            name={Math.random()}
            style={{
                border: "1px solid #808EA8",
                height: this.propInputHeight(),
                width: this.propInputWidth(),                 
                borderRadius: "4px",
                width: "100%",
                fontSize: "16px",
                color: `${this.propFontColor() == AppTextFieldConfig.fontColor.gray ? "#808EA8" : "#1D365E"}`,
                paddingLeft: this.propPrefixImageByCss() ? "40px" : "",               
                fontWeight: `${this.propFontWeight() == AppTextFieldConfig.fontWeight.bold ? "bold" : "normal"}`,
            }}
            format={
                this.propOnFormat() ? this.propOnFormat()(this.stateValue()) : null
            }
            mask="" 
            allowNegative={false}                       
            thousandSeparator={this.propPrefixType() == AppTextFieldConfig.prefixType.income}  
            decimalScale={this.propDecimalScale() || 0}          
            prefix={this.propPrefixText() || ""}
            suffix={this.propSuffixText() || ""}
            value={this.stateValue()}
            maxLength={this.propMaxLength()}                     
            onChange={(e) => {
                let currentText = e.target.value;
                if (this.propPrefixText()) {
                    currentText = currentText.replaceAll(this.propPrefixText(), "")
                }
    
                if (this.propSuffixText()) {
                    currentText = currentText.replaceAll(this.propSuffixText(), "")
                }
    
                // Ensure max length including prefix
                if (currentText.length <= (this.propMaxLength() - (this.propPrefixText() ? this.propPrefixText().length : 0))) {
                    // Convert currentText to a number and check if it's greater than 100
                    let currentNumber = parseFloat(currentText);
                    if (this.props.percentage && currentNumber > 100) {
                        currentText = "100";
                    }
                    this.onTextChange(currentText);
                }
            }}
            onBlur={(e) => {
                let currentText = e.target.value;                
                this.onTextBlur(currentText);
            }}
            onKeyDown={(e) => this.onKeyDown(e)}
            className={`form-control ${this.propPrefixImageByCss() ? this.propPrefixImageByCss() : ""}`}
            placeholder={this.propPlaceHolder()}
            disabled={this.propDisabled() == AppTextFieldConfig.disabled.true ? true : false}
            autocomplete="off"
            aria-autocomplete="none"
        />
    }        

    //Disabled number field
    disabledNumberField() {
        return <div
            id={this.propId() || ""}
            style={{
                border: "1px solid #808EA8",
                height: "40px",
                borderRadius: "4px",
                width: "100%",
                fontSize: "16px",
                color: `${this.propFontColor() == AppTextFieldConfig.fontColor.gray ? "#808EA8" : "#1D365E"}`,
                fontWeight: `${this.propFontWeight() == AppTextFieldConfig.fontWeight.bold ? "bold" : "normal"}`,
            }}
            className={`form-control-disabled`}
            placeholder={this.propPlaceHolder()}
            disabled={this.propDisabled() == AppTextFieldConfig.disabled.true ? true : false}
        >
            {(this.propPrefixType() == AppTextFieldConfig.prefixType.text && this.propPrefix()) && <span>{this.propPrefix()} </span>}<span>{UtilBloc.isNullOrEmpty(this.stateValue()) ? '-' : this.stateValue()}</span>
        </div>
    }

    render() {
        return <div >
            {
                this.propLabel() && <AppFieldTitle
                text={this.propLabel()}
                compulsory={this.propCompulsory() || this.propSubCompulsory()}
                fontColor={this.propLabelFontColor()}
            />
            }
            
            {
                this.propType() == AppTextFieldConfig.type.text ?
                    <div style={{ display: "block", width: "100%" }}>
                        {
                            this.propDisabled() == AppTextFieldConfig.disabled.true ? this.disabledTextField() : this.enabledTextField()
                        }
                        {
                            this.propSubtitle() && <AppFieldSubtitle
                                text={this.propSubtitle()}
                            />
                        }
                        <AppFieldError
                            text={this.onGetErrorLabel(this.stateError())}
                        />
                    </div>
                    : this.propType() == AppTextFieldConfig.type.number ?
                        <div style={{ display: "block", width: "100%" }}>
                            {
                                this.propDisabled == AppTextFieldConfig.disabled.true ? this.disabledNumberField() : this.enabledNumberField()
                            }
                            {
                                this.propSubtitle() && <AppFieldSubtitle
                                    text={this.propSubtitle()}
                                />
                            }
                            <AppFieldError
                                text={this.onGetErrorLabel(this.stateError())}
                            />
                        </div>
                        :
                        <></>
            }
        </div>
    }

}

export default AppTextField;
